import { Badge } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import Icon from '../../assets/icons/Icon';

const SidebarLink = (props) => {
    const { title, icon, newLink, route, onClick = () => null } = props;

    return (
        <NavLink
            to={route}
            className={({ isActive }) =>
                isActive ? "sidebar__link-active" : ""
            }
            onClick={onClick}
        >
            <li className="sidebar__link">
                {icon ? (
                    <Icon icon={icon} className="sidebar__link-icon" />
                ) : (
                    ''
                )}
                <p className="sidebar__link-title">
                    {title}
                    {newLink ? (
                        <Badge className="sidebar__link-badge">
                            <span>New</span>
                        </Badge>
                    ) : (
                        ''
                    )}
                </p>
            </li>
        </NavLink>
    );
};

export default SidebarLink;
